import { RosteringComponent } from "./rostering.component";
import { CreateRosteringComponent } from "./create-rostering/create-rostering.component";
import { CreateRouteComponent } from "./create-route/createRoute.component";
import { ManageRouteComponent } from "./manage-route/manageRoute.component";
import { RosteringTopMenuComponent } from './directives/rostering-top-menu/rostering-top-menu';
import {RosteringPickupPointManage } from './directives/pickup-point-manage/pickup-point-manage';
import { RosteringAddvehicleComponent } from "./directives/rostering-addvehicle/rostering-addvehicle.component";
import { RosteringAddmorevehicleComponent } from "./directives/rostering-addmorevehicle/rostering-addmorevehicle.component";
import { VehicleConfigrationComponent } from './directives/vehicle-configuration/vehicle.configuration.component';
import { RosteringSingleSelectMapComponent } from "./directives/rostering-single-select-map/rostering-single-select-map.component";
import { RosteringFavouriteLocationComponent } from "./directives/rostering-favourite-location/rostering-favourite-location.component";
import { RosteringGuestComponent } from "./directives/rostering-guest/rostering-guest.component";
import { RosteringEmpTypeChangeComponent } from "./directives/rostering-emp-type-change/rostering-emp-type-change.component";
import { routeConfigDeclartion } from "./route-configuration/route-configuration.declartion";
import { RosteringGlobalSearchComponent } from './directives/rostering-global-search/rostering-global-search.component';
import { RosterComponent } from "./directives/roster/roster.component";
import { RosterNewComponent } from "./Roster/roster-new.component";
import { RosterNewDeclaration } from "./Roster/roster-new.declaration";

export const RosteringDeclaration = [
  RosteringComponent,
  CreateRosteringComponent,
  CreateRouteComponent,
  ManageRouteComponent,  

  RosteringTopMenuComponent,
  RosteringPickupPointManage,
  RosteringAddvehicleComponent,
  RosteringAddmorevehicleComponent,
  VehicleConfigrationComponent,
  RosteringFavouriteLocationComponent,
  RosteringSingleSelectMapComponent,
  RosteringGuestComponent,
  RosteringEmpTypeChangeComponent,
  RosteringGlobalSearchComponent,
  RosterComponent,
  RosterNewComponent,

  routeConfigDeclartion,
  RosterNewDeclaration
];
